import { gql } from '@apollo/client'

export const Query = gql`
  query EditCustomField($companyId: ID!, $filters: CustomFieldFilters) {
    customFields(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        resourceType
        fieldType
        enabled
      }
    }
  }
`
